import {
    Alert,
    Box,
    Collapse,
    IconButton,
    Typography,
} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { de } from 'date-fns/locale/de';
import { enGB } from 'date-fns/locale';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';

import ArrowRightAltOutlinedIcon from '@mui/icons-material/ArrowRightAltOutlined';
import i18n from '../../i18n';

function DateTimeRangePicker({ start, end, labelStart, labelEnd, onChange, onDelete, error, date, disabled }) {
    let defaultStart = new Date(date);
    let defaultEnd = new Date(date);

    defaultStart.setHours(8);
    defaultEnd.setHours(16, 30);

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === 'de' ? de : enGB}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', my: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <Box>
                        <MobileDateTimePicker
                            value={start}
                            onAccept={(newValue) => onChange(newValue, end)}
                            label={labelStart}
                            format="EE dd.LL HH:mm"
                            openTo="hours"
                            onOpen={() => {
                                if (start === null)
                                    onChange(defaultStart, end)
                            }
                            }
                            slotProps={{ textField: { placeholder: '' } }}
                            disabled={disabled}
                        />
                    </Box>
                    <Box>
                        <ArrowRightAltOutlinedIcon />
                    </Box>
                    <Box>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <MobileDateTimePicker
                                value={end}
                                onAccept={(newValue) => onChange(start, newValue)}
                                label={labelEnd}
                                format="EE dd.LL HH:mm"
                                openTo="hours"
                                onOpen={() => {
                                    if (end === null)
                                        onChange(start, defaultEnd)
                                }
                                }
                                slotProps={{ textField: { placeholder: '' } }}
                                disabled={disabled}
                            />
                            <IconButton
                                sx={{ ml: 1, mr: .45, visibility: typeof onDelete !== 'undefined' ? 'visible' : 'hidden' }}
                                edge="end"
                                onClick={onDelete}
                                disabled={disabled}

                            >
                                <DeleteIcon />
                            </IconButton>
                        </div>
                    </Box>
                </Box>
            </Box>
            <Collapse in={error}>
                <Alert
                    sx={{ mb: 2 }}
                    severity="error"
                >
                    Startzeit liegt nach Endezeit
                </Alert>
            </Collapse>
        </LocalizationProvider>
    );
};

export default DateTimeRangePicker
